import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import ReactGA from 'react-ga4';
import { Common, PopUpBox } from '../../components';
import MobileSms from '../../assets/images/mobile-sms.svg';

import { actionSendOTP, actionLoginOTP, actionSendClientID } from '../../store/application/actions';
import { numberWithNoCommas } from '../../utils/common';
import { clearApplicationDraft, createApplicationFlowMeta, saveApplicationDraft } from '../../utils/applicationDraft';

const COUNT_TIMES = 4;

function ApplicationOTP() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();
  const [isVisibleTimeOverOTP, setIsVisibleTimeOverOTP] = useState(false);
  const [isVisibleWrongOTP, setIsVisibleWrongOTP] = useState(false);
  const [isVisibleExpiredOTP, setIsVisibleExpiredOTP] = useState(false);
  const [countTimes, setCountTimes] = useState(COUNT_TIMES);
  const [countView, setCountView] = useState(COUNT_TIMES + 1);
  const [resendDisabled, setResendDisabled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem('application_phone');
    if (!location.state?.phone) {
      navigate('/');
    }
  }, [location.state?.phone, navigate]);

  useEffect(() => {
    if (countTimes === 0 && !isVisibleExpiredOTP) {
      setIsVisibleTimeOverOTP(true);
    }
  }, [countTimes, isVisibleExpiredOTP]);

  const onReSendOTP = () => {
    if (resendDisabled) {
      return;
    }
    setResendDisabled(true);
    if (countTimes !== 0) {
      dispatch(
        actionSendOTP({
          phone: location.state?.phone,
        }),
      );
      setIsVisibleTimeOverOTP(false);
    } else {
      navigate('/?open=register');
    }
  };

  const onSubmit = async (data) => {
    const response = await dispatch(
      actionLoginOTP({
        phone: location.state?.phone,
        otp: data.otp,
        lendela_app_id: location.state?.lendela_app_id
      }),
    );
    if (response?.sts_code === 0) {
      // SUCCESS
      await localStorage.setItem('access_token', response?.content?.access_token);
      await localStorage.setItem('application_phone', location.state?.phone || '');
      const flowMeta = createApplicationFlowMeta({
        phone: location.state?.phone,
        lendelaAppId: location.state?.lendela_app_id,
        noDocLoanData: location.state?.no_doc_loan_data,
      });
      clearApplicationDraft();
      saveApplicationDraft({
        meta: flowMeta,
        currentStep: 'consent',
      });
      console.info(process.env.REACT_APP_GA_CODE);
      if (process.env.REACT_APP_GA_CODE) {
        ReactGA.initialize(process.env.REACT_APP_GA_CODE, {
          gaOptions: {
            userId: response?.content?.user_id,
          },
        });
        // ReactGA.send('pageview');
        ReactGA.ga(async (tracker) => {
          const clientId = tracker.get('clientId');
          await dispatch(
            actionSendClientID({
              client_id: clientId,
            }),
          );
        });
        ReactGA.set({ user_app_id: response?.content?.user_id });
      }
      navigate('/application-otp-success', {
        replace: true, state: {
          phone: location.state?.phone, path: '/application-consent',
          lendela_app_id: location.state?.lendela_app_id,
          no_doc_loan_data: location.state?.no_doc_loan_data
        }
      });
    } else if (response?.sts_code === 5) {
      // INVALID_OTP
      setValue('otp', '');
      setIsVisibleWrongOTP(true);
      setCountView(countView - 1);
    } else if (response?.sts_code === 6) {
      // EXPIRED_OTP
      setCountTimes(0);
      setIsVisibleExpiredOTP(true);
      setIsVisibleTimeOverOTP(false);
    } else if (response?.sts_code === 7) {
      // MAX_WRONG_INPUT_OTP
      setCountTimes(0);
      setIsVisibleTimeOverOTP(true);
    } else {
      setCountTimes(countTimes - 1);
    }
  };

  return (
    <>
      <Common.Loading isVisible={isSubmitting} />
      <div className="bg-white p-5">
        {isVisibleTimeOverOTP && <PopUpBox.TimeOverOTP onClick={onReSendOTP} number={countTimes}>
          <div className="text-center my-3">
            <button onClick={onReSendOTP} type="button" className="rounded-full text-white text-sm bg-primary px-12 py-3">
              確定
            </button>
          </div>
        </PopUpBox.TimeOverOTP>}
        {isVisibleWrongOTP && !isVisibleExpiredOTP && (
          <PopUpBox.Error
            onClick={() => {
              setIsVisibleWrongOTP(false);
            }}
            content=""
          >
            <div className="text-center">
              {countView > 0 && <p className="text-gray1 my-6"> 驗證碼錯誤 <span className="text-primary2">(剩餘{countView}次)</span></p>}
              <button onClick={() => {
                setIsVisibleWrongOTP(false);
              }} type="button" className="rounded-full text-white text-sm bg-primary px-12 py-3">
                重新輸入
              </button>
            </div>
          </PopUpBox.Error>
        )}
        {isVisibleExpiredOTP && (
          <PopUpBox.Error
            onClick={() => {
              setIsVisibleExpiredOTP(false);
            }}
            content="驗證超時，按此取得新的驗證碼。"
          >
            <div className="text-center">
              <button onClick={() => {
                dispatch(
                  actionSendOTP({
                    phone: location.state?.phone,
                  }),
                );
                setCountTimes(1)
                setValue('otp', '')
              }} type="button" className="rounded-full text-white text-sm bg-primary px-14 py-2 mt-3">
                確定
              </button>
            </div>
          </PopUpBox.Error>
        )}
        <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">安全驗證</p>
        <div className="flex justify-center mb-5">
          <img src={MobileSms} alt="" />
        </div>
        <p className="text-gray mb-4 text-center">驗證碼已發送到閣下登記之手提電話號碼</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-12 mb-2">
            <input
              inputMode='numeric'
              {...register('otp', {
                required: true,
                onChange: (e) => {
                  const value = numberWithNoCommas(e?.target?.value)
                  setValue('otp', value)
                }
              })}
              className="border-b border-primary2 w-full h-10 outline-none px-2 text-center text-primary2"
              style={{ marginBottom: -5 }}
              placeholder="請在此輸入驗證碼"
              maxLength={6}
            />
            {errors.otp && errors.otp.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
          </div>
          <p className="text-8 mb-6 text-center text-gray">
            未能收到驗證碼？
            <span className={`${!resendDisabled ? 'text-primary cursor-pointer' : 'text-gray cursor-not-allowed'} underline`} onClick={onReSendOTP}>
              取得新的驗證碼
            </span>
          </p>
          <div className="flex justify-center mb-4">
            <button type="submit" disabled={isSubmitting} className={`rounded-full text-white text-xl px-14 py-2 ${isSubmitting ? 'bg-mercury' : 'bg-primary'}`}>
              提交
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ApplicationOTP;
